import { FunctionComponent, memo, useCallback, useRef, useState } from 'react';

import Button from '../common/button';
import NamePlateModal from '.';
import { ButtonNamePlateProps, IProps } from './name-plate-modal.type';

const NamePlateButton = (props: ButtonNamePlateProps) => {
	const { label = '추가', className, ...rest } = props;

	const [open, setOpen] = useState(false);

	const namePlateModal = useRef<FunctionComponent<IProps>>();

	const onOpenModal = useCallback(() => {
		if (!namePlateModal.current) {
			namePlateModal.current = NamePlateModal;
		}

		setOpen(true);
	}, []);

	const onCancel = useCallback(() => {
		setOpen(false);
	}, []);

	return (
		<>
			<Button secondary className={className} onClick={onOpenModal}>
				{label}
			</Button>

			{namePlateModal.current && (
				<namePlateModal.current {...{ ...rest, open, onCancel }} />
			)}
		</>
	);
};

export default memo(NamePlateButton);
